import { TextAreaProps } from 'antd/es/input';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { Input, InputBackgroundColor, InputBorder, InputFocus } from './input';

export const TextArea = styled(Input.TextArea)<TextAreaProps>`
  padding: var(--spacing-04) var(--spacing-05);
  background-color: ${InputBackgroundColor};
  resize: none;
  ${BodyShort01};
  ${InputBorder};
  &:focus {
    ${InputFocus};
  }
  &.ant-input[disabled] {
    opacity: 0.5;
  }
`;
